import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import * as Styles from "../../styles.ts";
import "../dui/spinner/dui-spinner.ts";

const styles = css`
  :host {
    --inset-x: 0;
    --loading-size: var(--space-6);
    display: block;
    height: var(--loading-size);
  }

  .loading {
    color: var(--muted-foreground);
    display: flex;
    align-items: center;
    gap: var(--space-1);
    font-size: var(--font-size-sm);
    line-height: var(--line-height-snug);
    height: var(--loading-size);
    font-style: italic;
    white-space: nowrap;
    padding: var(--space-2) var(--inset-x, 0);
  }

  .loading-svg {
    display: block;
    width: var(--loading-size);
    height: var(--loading-size);
  }
`;

@customElement("loading-text")
export class LoadingText extends LitElement {
  static override styles = [Styles.base, styles];

  @property({ type: String })
  accessor label = "Loading...";

  override render() {
    return html`
      <div class="loading">
        <dui-spinner></dui-spinner>
        <div>${this.label}</div>
      </div>
    `;
  }
}
